import { useEffect, useState } from 'react'
import { Select } from 'antd'
import service from '../../@services'
import { connect } from 'react-redux'
import store from '../../@store'

function ShopSelect(props) {
  const {
    style = {},
    onChange = () => { },
    OnOptionsLoad = () => { },
    storeList,
    mode = '',
    value,
    defaultStoreCode = '',
    keyVal = 'storeCode',
    disabled = false,
    placeholder = '请选择门店'
  } = props
  useEffect(() => {
    if (!storeList) {
      service.common.getStoreList()
    } else {
      const defaultStore =
        storeList.filter((item) => item.storeCode === defaultStoreCode)[0] ||
        storeList[0]
      defaultStore && OnOptionsLoad && OnOptionsLoad(defaultStore, storeList)
    }
    return () => { }
  }, [storeList])
  // useEffect(()=>{
  //   selectedStore.storeCode && onChange(selectedStore.storeCode)
  // },[selectedStore])
  const _onChange = (val) => {
    if (keyVal == 'id') {
      let code = (storeList.filter((item) => item.id == val)[0] || {}).storeCode
      store.dispatch({ type: 'common/storeCode', payload: code })
    } else {
      store.dispatch({ type: 'common/storeCode', payload: val })
    }
    onChange && onChange(val)
  }
  return (
    <Select
      style={{ width: '140px', ...style, textAlign: 'left' }}
      placeholder={placeholder}
      mode={mode}
      value={value}
      disabled={disabled}
      onChange={_onChange}
    >
      {storeList &&
        storeList.map((item) => (
          <Select.Option key={item[keyVal]} value={item[keyVal]}>
            {item.storeName}
          </Select.Option>
        ))}
    </Select>
  )
}

export default connect((state) => ({
  storeList: state.common.storeList,
  defaultStoreCode: state.common.storeCode,
}))(ShopSelect)
